/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	IAdminAuthUserResponseData,
	IAdminLogoutData,
	IAuthStore,
	IAuthRefreshTokenRequestPayload,
	IMerchantIdPayload,
	IAuthConnectResponsePayload,
	IAuthConnectRequestPayload,
	ILogoutRequestPayload,
	TGetAvailableReportTypesResponsePayload,
	TSavedUrl,
	IAuthRefreshTokenResponseData,
} from './types';

// ==========================================:
export const initialState: IAuthStore = {
	accessToken: null,
	refreshToken: null,
	socketToken: null,
	isAuthenticated: false,
	adminLogoutLoader: false,
	email: null,
	loginEmail: null,
	loginPassword: null,
	remember: false,
	userData: null,
	xMerchantId: null,
	connect: null,
	connectLoader: false,
	availableStandardVatReportTypes: null,
	availableStandardVatReportTypesLoader: false,
	availableVatReportTypes: null,
	availableVatReportTypesLoader: false,
	savedUrl: null,
	refreshTime: 0,
	refreshTokenResponse: null,
	refreshTokenLoader: false,
	localStorageMessage: null,
	inactivityLogout: false,
};

// ==========================================:
const auth = createSlice({
	name: '@@auth',
	initialState,
	reducers: {
		loginSuccess: (state: IAuthStore, action: PayloadAction<IAdminAuthUserResponseData>) => {
			const { payload } = action;
			const loginState = state;

			loginState.isAuthenticated = true;
			loginState.refreshTokenLoader = false;

			loginState.accessToken = payload.token;
		},
		logoutRequest: (state: IAuthStore, action: PayloadAction<ILogoutRequestPayload>) => {
			const logoutState = state;

			logoutState.adminLogoutLoader = true;
		},
		authInitState: (state: IAuthStore) => {
			const authInitStateState = state;
			return { ...initialState, savedUrl: authInitStateState.savedUrl };
		},
		authInitStateInactivity: (state: IAuthStore) => {
			const authInitStateState = state;
			return { ...initialState, savedUrl: authInitStateState.savedUrl, inactivityLogout: true };
		},
		refreshTokenRequest: (
			state: IAuthStore,
			action: PayloadAction<IAuthRefreshTokenRequestPayload>,
		) => {
			const { payload } = action;
			const refreshTokenState = state;
			refreshTokenState.refreshToken = payload?.refresh_token ?? null;
			// refreshTokenState.refreshTokenLoader = true;
		},
		refreshTokenSuccess: (state: IAuthStore, action: PayloadAction<number>) => {
			const { payload } = action;
			const refreshTokenResponseState = state;
			refreshTokenResponseState.refreshTime = payload;
			refreshTokenResponseState.refreshTokenLoader = false;
		},
		refreshTokenByTimeOutRequest: (state: IAuthStore) => {},

		setRefreshTokenByTimeOutLoading: (state: IAuthStore) => {
			const refreshTokenState = state;
			refreshTokenState.refreshTokenLoader = true;
		},

		refreshTokenByTimeOutSuccess: (state: IAuthStore) => {
			const refreshTokenState = state;
			refreshTokenState.refreshTokenLoader = false;
		},

		getMerchantIdSuccess: (state: IAuthStore, action: PayloadAction<IMerchantIdPayload>) => {
			const { payload } = action;
			const merchantIdState = state;
			merchantIdState.xMerchantId = payload?.xMerchantId ?? null;
		},
		getConnectRequest: (state: IAuthStore, action: PayloadAction<IAuthConnectRequestPayload>) => {
			const { payload } = action;

			const connectRequestState = state;
			connectRequestState.connectLoader = true;
		},
		getConnectSuccess: (state: IAuthStore, action: PayloadAction<IAuthConnectResponsePayload>) => {
			const { payload } = action;
			const connectSuccessState = state;
			connectSuccessState.connect = payload;
			connectSuccessState.connectLoader = false;
			connectSuccessState.accessToken = payload?.access_token ?? null;
			connectSuccessState.refreshToken = payload?.refresh_token ?? null;
		},
		getAvailableReportTypesRequest: (state: IAuthStore) => {
			const reportsState = state;
			reportsState.availableStandardVatReportTypesLoader = true;
			reportsState.availableVatReportTypesLoader = true;
		},
		getAvailableReportTypesSuccess: (
			state: IAuthStore,
			action: PayloadAction<TGetAvailableReportTypesResponsePayload>,
		) => {
			const { payload } = action;
			const reportsState = state;
			reportsState.availableStandardVatReportTypes = payload?.standardReports ?? null;
			reportsState.availableVatReportTypes = payload?.fiscalReports ?? null;
			reportsState.availableStandardVatReportTypesLoader = false;
			reportsState.availableVatReportTypesLoader = false;
		},
		saveUrl: (state: IAuthStore, action: PayloadAction<TSavedUrl>) => {
			const { payload } = action;
			const saveUrlState = state;
			saveUrlState.savedUrl = payload;
		},
		setLocalStorageMessage: (state: IAuthStore, action: PayloadAction<string>) => {
			const { payload } = action;
			const setLocalStorageMessageState = state;
			setLocalStorageMessageState.localStorageMessage = payload;
		},
	},
});

export default auth.reducer;
export const {
	loginSuccess,
	logoutRequest,
	authInitState,
	authInitStateInactivity,
	refreshTokenRequest,
	refreshTokenSuccess,
	getMerchantIdSuccess,
	getConnectRequest,
	getConnectSuccess,
	getAvailableReportTypesRequest,
	getAvailableReportTypesSuccess,
	refreshTokenByTimeOutRequest,
	setRefreshTokenByTimeOutLoading,
	refreshTokenByTimeOutSuccess,
	saveUrl,
	setLocalStorageMessage,
} = auth.actions;
